import { Network } from "junco/src/network"
import { GenericInput } from "./Inputs"
import { useState, useEffect } from "react"

const StructureControls = ({
  netStructure,
  setNetStructure,
}) => {

  const [newStructure, setNewStructure] = useState(netStructure)

  useEffect(() => setNewStructure(netStructure), [netStructure])

  // update structure state when input changed
  const handleStructureChange = (e) => {
    var newStructureVar = [...newStructure]

    const i = e.target.dataset.i
    const val = Number(e.target.value)
 
    newStructureVar[i] = val
    setNewStructure(newStructureVar)
  }

  // remove layer when button clicked
  const handleLayerRemoval = (e) => {
    e.preventDefault()

    const i = e.target.dataset.i
    console.log(i)
    var newStructureVar = newStructure.filter((_, j) => j !== Number(i))
    console.log(newStructureVar)
    setNewStructure(newStructureVar) 
  }

  // add layer when button clicked
  const handleLayerAddition = (e) => {
    e.preventDefault()

    const i = Number(e.target.dataset.i)
    const newStructureVar = [...newStructure]
    console.log(newStructureVar)
    const newLayerDefault = 5

    newStructureVar.splice(i+1, 0, newLayerDefault)
    console.log(newStructureVar)

    setNewStructure(newStructureVar)
  }

  return (
    <div>
      <h3>Structure</h3>
      <form onSubmit={e => {e.preventDefault(); setNetStructure(newStructure)}}>
        <div className="controlRow">
          Inputs: <b>{netStructure[0]}</b>
        </div>
        <div className="controlRow" style={{border: "none"}}>
          <button data-i={0} className="controlRow" onClick={handleLayerAddition}>Add layer</button>
        </div>
        {newStructure.slice(1, -1).map((neurons, i) => 
          <div key={i}>
            <div className="controlRow" key={i}>
              <button
                type="button"
                data-i={i+1}
                style={{float: 'left'}}
                onClick={handleLayerRemoval}
              >x</button>
              Hidden Layer {i+1}: 
              <input
                className="number-input"
                style={{
                  marginLeft: '.5vw',
                  width: "10%",
                }}
                value={neurons}
                data-i={i+1}
                type="number"
                onChange={handleStructureChange}
              ></input>

            </div>
            <div className="controlRow" style={{border: "none"}}>
              <button data-i={i+1} onClick={handleLayerAddition} className="controlRow">
                Add layer
              </button>
            </div>
          </div>
        )}
        <div className="controlRow">
          Outputs: <b>{netStructure.slice(-1)}</b>
        </div>
        <button type="submit">Update</button>
      </form>
    </div>
  )
}

const InputControls = ({
  inputs,
  setInputs,
  network,
  setNetworkOutput,
  setLoss,
  expectedOutputs,
  dataset
}) => {
  // scaled inputs

  const scaledInputs = useState([])

  // change input state when form changed
  const handleInputChange = (event) => {
    var newInputs = [...inputs]
    const i = event.target.dataset.i
    const val = Number(event.target.value)

    newInputs[i] = val
    setInputs(newInputs)
  }
  
  const handleExampleChange = event => {
    const i = event.target.value

    const example = dataset.data.test[i]

    console.log(dataset)
    const unscaledX = example.X.map((input, j) => {
      // unscale
      const b = dataset.scaling.unscaled_mins[j]
      const m = dataset.scaling.unscaled_maxes[j] - dataset.scaling.unscaled_mins[j]

      return input * m + b
    })

    setInputs(unscaledX)
  }

  // evaluate new output of network
  const updateOutput = (event) => {
    event.preventDefault()

    // scaled inputs 
    var scaled = []
    if(dataset.scaling.scaled) {
      scaled = inputs.map((input, i) => {
        const b = dataset.scaling.unscaled_mins[i]
        const m = dataset.scaling.unscaled_maxes[i] - dataset.scaling.unscaled_mins[i]
        return (input - b) / m
      })
    }
    else {
      scaled = inputs
    }
    console.log(scaled)

    var o = network.evaluate(scaled)
    setNetworkOutput(o)

    setLoss(o.loss(expectedOutputs))
  }

  const handleFocus = e => e.target.select()

  return (
    <form onSubmit={updateOutput}>
    <table>
      {
        inputs.map((el, i) => {
          return (
            <tr key={i}>
            <td>
              <label>{dataset ? dataset.feature_names[i] : ''}  </label>
            </td>
            <td >
              <input
                style={{width: "100%"}}
                type="number"
                id={i}
                data-i={i}
                onChange={handleInputChange}
                value={Math.round(inputs[i] * 1000)/1000}
                onFocus={e => e.target.select()}
                className="genericInput"
              >
              </input>
            </td>
        </tr>
          )
        })
      }
    </table>
    <select onChange={handleExampleChange}>
      {dataset && dataset.data.test.map((example, i) => {
        var className = dataset.class_names[example.y.findIndex(v => v == 1)]

        if(!className && "null_class" in dataset) {
          className = dataset.null_class
        }

        return <option key={i} value={i}>
          {className} ({i})
        </option>
      })}
      </select>
    <button type="submit">Run</button>
</form>
  )
}

export {
  StructureControls,
  InputControls
}